import { useMutation } from '@tanstack/react-query';

import { postData } from 'src/app/queries';

const EXPORT_CAMPAIGN_AUDIENCE = 'api/marketing-campaign/export-campaign-audience';

type ExportAudienceRequest = {
  EndDate?: string;
  MarketingCampaignId: string;
  StartDate?: string;
};

export function useExportAudience() {
  return useMutation({
    mutationKey: ['export-audience'],
    mutationFn: (marketingCampaignId: number) =>
      postData<ExportAudienceRequest, string>({
        endpoint: EXPORT_CAMPAIGN_AUDIENCE,
        payload: {
          MarketingCampaignId: marketingCampaignId.toString(),
        },
        options: {
          responseType: 'blob',
        },
      }),
  });
}

export function useExportAudienceV2() {
  return useMutation({
    mutationKey: ['export-audience'],
    mutationFn: ({
      marketingCampaignId,
      startDate,
      endDate,
    }: {
      endDate?: string;
      marketingCampaignId: number;
      startDate?: string;
    }) =>
      postData<ExportAudienceRequest, string>({
        endpoint: EXPORT_CAMPAIGN_AUDIENCE,
        payload: {
          MarketingCampaignId: marketingCampaignId.toString(),
          StartDate: startDate,
          EndDate: endDate,
        },
        options: {
          responseType: 'blob',
        },
      }),
  });
}
